import Vue from 'vue'
import resource from 'vue-resource'
import App from './App.vue'
import router from './router'
import store from './vuex'
import 'vue-event-calendar/dist/style.css'
import vueEventCalendar from 'vue-event-calendar'
import vueCalendar from 'vue-calendar-component'

Vue.config.productionTip = false

import iView from 'iview';
import 'iview/dist/styles/iview.css';

Vue.use(iView);
Vue.use(resource);
Vue.use(vueEventCalendar, {className: 'selected-day'});
Vue.use(vueCalendar)

require('froala-editor/js/plugins.pkgd.min.js')
require('froala-editor/js/languages/zh_cn')
require('froala-editor/js/third_party/image_tui.min')
// Require Froala Editor js file.
require('froala-editor/js/froala_editor.pkgd.min.js')

// Require Froala Editor css files.
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)

Vue.http.options.root= '/food' // 配置请求前缀
Vue.http.options.emulateJSON = true

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  to.matched.some((route) => {
    // if (!route.meta.login) {
    //   if (store.systemUser == null) {
    //     next('/')
    //   }
    // }
    next()
  });
});

router.afterEach(route => {
  iView.LoadingBar.finish();
});

Vue.filter('dateTimeToString', function (value,string) {
  string = string || ""
  if (value == null || value == '') return string
  let time = new Date(value)
  let y = time.getFullYear();
  let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
  let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
  let h = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
  let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
  let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
  return y+'-'+m+'-'+d+' '+h+':'+mm+':'+s;
})



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.prototype.myError = function (item) {
    if (item.code === '201') {
        this.$Notice.error({title:"登录过期，请重新登录"});
        console.log('提示重新登录')
        this.$router.push('/')
        return
    }
  switch (item.status) {
    case 200:
      this.$Notice.error({title:"服务器异常，请联系管理员"});
      break
    case 403:
        this.$Notice.error({title:"登录过期，请重新登录"});
        console.log('提示重新登录')
        this.$router.push('/')
        break
    case 404:
      if (item.message.indexOf("Subject") == 0){
        this.$Notice.error({title:"权限不足，请尝试重新登录或联系管理员"});
      } else{
        this.$Notice.error({title:item.message});
      }
      break
    default:
      this.$Notice.error({title:"服务器异常，请联系管理员"});
      break
  }
}
